import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ehrTabIdentifier: {
    index: '0',
    name: '',
  },
  practitionerTabIdentifier: {
    index: '0',
    name: '',
    options: {},
  },
};

const tabControllerSlice = createSlice({
  name: 'tabController',
  initialState,
  reducers: {
    setEhrTab: (state, action) => {
      const { index, name } = action?.payload;
      state.ehrTabIdentifier = {
        index,
        name,
      };
    },
    setPractitionerTab: (state, action) => {
      const { index, name, options = {} } = action?.payload;
      state.practitionerTabIdentifier = {
        index,
        name,
        options,
      };
    },
  },
});

export const { setEhrTab, setPractitionerTab } = tabControllerSlice?.actions;
export default tabControllerSlice?.reducer;
